var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      {
        attrs: {
          value: _vm.value,
          filterable: "",
          placeholder: "请选择告警通知人",
          clearable: "",
          multiple: "",
        },
      },
      _vm.listeners
    ),
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name, value: item.id },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }